/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
import config from './config';
import API from './api/API';

function urlBase64ToUint8Array(base64String: any) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  // eslint-disable-next-line
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

const convertedVapidKey = urlBase64ToUint8Array(config.webpush.vapidKeyPublic);

function sendSubscription(subscription: any) {
  return API.post('/webpush/subscribe', subscription);
}

export default function subscribeUser() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        if (!registration.pushManager) {
          return;
        }

        registration.pushManager
          .getSubscription()
          .then((existedSubscription) => {
            if (existedSubscription === null) {
              registration.pushManager
                .subscribe({
                  applicationServerKey: convertedVapidKey,
                  userVisibleOnly: true,
                })
                .then((newSubscription) => {
                  sendSubscription(newSubscription);
                })
                .catch((e) => {
                  if (Notification.permission !== 'granted') {
                    console.log('Permission was not granted.');
                  } else {
                    console.error(
                      'An error ocurred during the subscription process.',
                      e,
                    );
                  }
                });
            } else {
              sendSubscription(existedSubscription);
            }
          });
      })
      .catch((e) => {
        console.error(
          'An error ocurred during Service Worker registration.',
          e,
        );
      });
  }
}
